export enum PhoneType {
  MOBILE = 'MOBILE',
  WORK = 'WORK',
  UNDEFINED = 'UNDEFINED',
}
